<div class="min-h-screen bg-gray-50">
  <div class="flex h-screen bg-gray-50">
    <app-sidebar></app-sidebar>
    <div class="font flex-1 flex flex-col overflow-hidden lg:ml-0">
      <header class="bg-white shadow-sm border-b border-gray-200 p-4 lg:px-6">
        <div class="flex items-center justify-between">
          <button class="lg:hidden text-gray-500 hover:text-gray-700" (click)="toggleMobileMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-menu w-6 h-6">
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </button>
          <div class="flex-1 lg:flex lg:items-center lg:justify-between">
            <h6 class="text-lg font-semibold text-gray-900 ml-4 lg:ml-0">{{'SIDEBAR.HIRED' | translate}}</h6>
          </div>
        </div>
      </header>
      <main class="flex-1 overflow-auto p-4 lg:p-6">
        <div class="space-y-6">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 class="text-2xl font-bold text-gray-900">{{'CANDIDATES.HIRED_CANDIDATES' | translate}}</h1>
              <p class="mt-1 text-gray-600">{{'CANDIDATES.SUCCESSFULLY_HIRED_TEAM_MEMBERS' | translate}}</p>
            </div>
            <div class="mt-4 sm:mt-0 bg-green-100 text-green-800 px-4 py-2 rounded-lg font-medium">
              {{hiredCandidates.length}} {{'SIDEBAR.HIRED' | translate}}
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center">
                <div class="bg-green-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-award w-6 h-6 text-white">
                    <circle cx="12" cy="8" r="6"></circle>
                    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
                  </svg>
                </div>
                <div class="ml-4">
                  <p class="text-sm font-medium text-gray-500">{{'CANDIDATES.TOTAL_HIRED' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900">{{statistics?.hiredCount}}</p>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center">
                <div class="bg-blue-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-star w-6 h-6 text-white">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                </div>
                <div class="ml-4">
                  <p class="text-sm font-medium text-gray-500">{{'CANDIDATES.SUCCESS_RATE' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900">{{statistics?.successRate}}%</p>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <div class="flex items-center">
                <div class="bg-purple-500 p-3 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-calendar w-6 h-6 text-white">
                    <path d="M8 2v4"></path>
                    <path d="M16 2v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18"></path>
                  </svg>
                </div>
                <div class="ml-4">
                  <p class="text-sm font-medium text-gray-500">{{'CANDIDATES.THIS_MONTH' | translate}}</p>
                  <p class="text-2xl font-bold text-gray-900">{{statistics?.hiredThisMonthCount}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div *ngIf="hiredCandidates.length === 0" class="col-span-full text-center py-12">
              <div class="bg-white rounded-xl p-8 shadow-sm border border-gray-100">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-user-search mx-auto text-gray-400 mb-4">
                  <circle cx="10" cy="7" r="4"></circle>
                  <path d="M10.3 15H7a4 4 0 0 0-4 4v2"></path>
                  <circle cx="17" cy="17" r="3"></circle>
                  <path d="m21 21-1.9-1.9"></path>
                </svg>
                <h3 class="text-lg font-medium text-gray-900 mb-2">{{'CANDIDATES.NO_HIRED_CANDIDATES_YET' | translate}}</h3>
              </div>
            </div>

            <div *ngFor="let candidate of hiredCandidates; trackBy: trackByFn"
                 class="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex flex-col justify-between">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 rounded-full flex items-center justify-center overflow-hidden">
                  <ng-container *ngIf="candidate?.profilePicture?.url; else initials">
                    <img [src]="candidate?.profilePicture?.url" alt="{{ candidate.firstName }}" class="w-full h-full object-cover">
                  </ng-container>
                  <ng-template #initials>
                    <div class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                      <span class="text-green-600 font-semibold text-lg">
                        {{ candidate.firstName?.charAt(0) }}
                      </span>
                    </div>
                  </ng-template>
                </div>

                <div class="ml-3">
                  <h3 class="text-lg font-semibold text-gray-900">{{candidate.firstName}} {{candidate.lastName}}</h3>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-award w-3 h-3 mr-1">
                      <circle cx="12" cy="8" r="6"></circle>
                      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
                    </svg>
                    {{'SIDEBAR.HIRED' | translate}}
                  </span>
                </div>
              </div>
              <div class="space-y-3 mb-4">
                <div class="flex items-center text-sm text-gray-600">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-mail w-4 h-4 mr-2">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="M22 7-10 5L2 7"></path>
                  </svg>
                  <span class="truncate">{{candidate.emailAddress}}</span>
                </div>
                <div class="flex items-center text-sm text-gray-600">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-phone w-4 h-4 mr-2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <span>{{candidate.phoneNumber}}</span>
                </div>
                <div class="flex items-center text-sm text-gray-600">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-calendar w-4 h-4 mr-2">
                    <path d="M8 2v4"></path>
                    <path d="M16 2v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18"></path>
                  </svg>
                  <span>
                    {{'CANDIDATES.HIRED_ON' | translate}}
                    {{candidate.statusUpdatedDate | date: 'MM/dd/yyyy'}}
                  </span>
                </div>
              </div>
              <div class="mb-4">
                <p class="text-sm font-medium text-gray-700 mb-2">{{'CANDIDATES.EXPERIENCE' | translate}}:</p>
                <p class="text-sm text-gray-600" [attr.title]="candidate?.jobApplicationSections[0]?.jobApplicationSectionProperties[4]?.stringValue">{{candidate?.jobApplicationSections[0]?.jobApplicationSectionProperties[4]?.stringValue}}</p>
              </div>
              <div class="mb-4">
                <p class="text-sm font-medium text-gray-700 mb-2">{{'CANDIDATES.WAGE' | translate}}:</p>
                <p class="text-lg font-semibold text-gray-900">$20/hour</p>
              </div>
              <div class="mb-4">
                <p class="text-sm font-medium text-gray-700 mb-2">{{'CANDIDATES.SKILLS' | translate}}:</p>
                <div class="flex flex-wrap gap-1">
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    Commercial Cleaning
                  </span>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    Floor Care
                  </span>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    Safety Protocols
                  </span>
                </div>
              </div>
              <div class="pt-4 border-t border-gray-200">
                <a [href]="'/candidates/' + candidate.id" class="w-full bg-green-50 hover:bg-green-100 text-green-700 py-2 px-4 rounded-lg text-center font-medium transition-colors inline-flex items-center justify-center">
                  {{'CANDIDATES.VIEW_PROFILE' | translate}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</div>
